module.exports = __webpack_public_path__ + "static/media/signaturepen.a732445f.svg";